import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import { FETCH_PRODUCTION_PLAN } from "./graphql";
import PlanForm from "./PlanForm";

const PlanDetail = () => {
  const { id } = useParams();

  const { loading, error, data } = useQuery(FETCH_PRODUCTION_PLAN, {
    variables: { id },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <PlanForm
      originalPlan={data.productionPlan}
      disabled={data.productionPlan.state !== "DRAFT"}
    />
  );
};

export default PlanDetail;
